// https://medium.com/locale-ai/architecting-http-clients-in-vue-js-applications-for-efficient-network-communication-991cf1df1cb2
import axios from 'axios'
import ThrowManager from '@/library/ThrowManager/throwManager.js'

import { LOGIN_THROW_UNIQUE_ID_SERVICE, LOGIN_THROW_ENDPOINT_MISSED, LOGIN_THROW_SIGN_MISSED } from '@/library/ThrowManager/throwList.js'

/** Auth token interceptors */
const authInterceptor = config => {
    /** TODO: Add auth token */
    return config;
}

/** logger interceptors */
const loggerInterceptor = config => {
    /** TODO */
    return config;
}

class httpClient {
    constructor() {
        // create new instance of AXIOS
        this._HTTP = axios.create({
            baseUrl: process.env.VUE_APP_HTTP_CLIENT_BASE_URL,
            timeout: process.env.VUE_APP_HTTP_CLIENT_TIMEOUT,
            headers: {
                'Content-Type': 'application/json'
            }
        })

        this._HTTP.interceptors.request.use(authInterceptor);
        this._HTTP.interceptors.request.use(loggerInterceptor);

        /** Adding the response interceptors */
        this._HTTP.interceptors.response.use(
            response => {
                /** TODO: Add any response interceptors */
                return response;
            },
            error => {
                /** TODO: Do something with response error */
                return Promise.reject(error);
            }
        );
        
        this._tm = new ThrowManager(LOGIN_THROW_UNIQUE_ID_SERVICE)
    }
    
    simpleGet (path) {
        // call HTTP request
        return this._HTTP.get(path)
    }

    get(API_REQUEST, PAYLOAD) {
        this._checkApiRequest(API_REQUEST, PAYLOAD)

        // call HTTP request
        this._HTTP.get(API_REQUEST.ENDPOINT, { params: { PAYLOAD } })
    }

    simplePost (path) {
        return this._HTTP.post(path)
    }

    _checkApiRequest(API_REQUEST, PAYLOAD) {
        // check API_REQUEST format
        if (API_REQUEST.ENDPOINT == null) this._tm.throw(LOGIN_THROW_ENDPOINT_MISSED.code, LOGIN_THROW_ENDPOINT_MISSED.message)
        if (API_REQUEST.SIGN == null) this._tm.throw(LOGIN_THROW_SIGN_MISSED.code, LOGIN_THROW_SIGN_MISSED.message)

        // check API REQUEST params with JSON SCHEMA ??? TODO!!
        if (PAYLOAD) return null
    }

}

export default new httpClient()